/*
 * Copyright 2020 The Kubeflow Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from 'react';
import SuccessIcon from '@mui/icons-material/CheckCircle';
import CachedIcon from '@mui/icons-material/Cached';

export default class StatusCached extends React.Component<{ style: any }> {
  public render(): React.JSX.Element {
    const { style } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <SuccessIcon style={{ ...style }} />
        <div>
          {/* We use this div because parent element has weird padding and this seems to workaround it */}
          <CachedIcon style={{ ...style }} />
        </div>
      </div>
    );
  }
}
